export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_OFFBOARDING_CATEGORY":
      return action.payload;
    case "CREATE_OFFBOARDING_CATEGORY":
      return [...state, action.payload];
    default:
      return state;
  }
};
